import React from 'react';
import { LoadingContainer } from 'app/components/LoadingContainer';
import { lazyLoad } from 'utils/loadable';

export const ReservationHistory = lazyLoad(
  () => import('./index'),
  module => module.ReservationHistoryPage,
  { fallback: <LoadingContainer loading /> },
);
